import {ValidationStatus} from 'services/User';

const Input = ({
  className,
  message,
  ...props
}: React.PropsWithRef<React.InputHTMLAttributes<HTMLInputElement>> & {
  message?: ValidationStatus;
}) => {
  const color = message?.status === 'error' ? 'text-error' : 'text-warning';
  return (
    <div className="">
      <input
        {...props}
        className={`w-full px-4 py-2 mb-2 border-2 hover:border-label focus:border-label focus:outline-none hover:outline-none rounded border-brand-sage ${className}`}
      />
      {message?.description !== undefined && (
        <p className={`text-sm ${color} -mt-1 mb-2`}>{message.description}</p>
      )}
    </div>
  );
};

export default Input;
